/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { t } from "i18next";
import PropTypes from "prop-types";

function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  const norm = path.replace(/\[(\w+)\]/g, ".$1").replace(/\['([^']+)'\]/g, ".$1");
  return norm.split(".").filter(Boolean).reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
}

function DynamicDropDownlist({
  label,
  formik,
  fieldName,
  disabled = false,
  loadingKey,
  dataKey,
  fetchAction,
  errorKey,
  dataName = "name",
  dataName2 = null,
  modalDialog = null,
  modalOptionLabel = null,
  onChange = null,
  extraQueryParams = null,
  multiple = false,
}) {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");
  const formState = useSelector((state) => state.form);
  const [options, setOptions] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);


  const resolvedErrorPath = errorKey || fieldName;
  const currentValue = getByPath(formik?.values, fieldName) ?? (multiple ? [] : null);
  const touched = getByPath(formik?.touched, resolvedErrorPath);
  const errorMsg = getByPath(formik?.errors, resolvedErrorPath);
  const hasError = Boolean(touched && errorMsg);

  if (label === "Exporter Name") {
  }

 



     useEffect(() => {
  if (formState[loadingKey] === "succeeded") {
    const cacheKey = JSON.stringify(extraQueryParams || {});  
    const newOptions = formState[dataKey]?.[cacheKey] || [];

    setOptions(newOptions);
  }
}, [formState[loadingKey], extraQueryParams]);



  useEffect(() => {
    const timeoutId = setTimeout(() => {
     const cacheKey = JSON.stringify(extraQueryParams || {});
      dispatch(fetchAction({ name: inputValue, extraQueryParams ,cacheKey })); // أضف extraQueryParams هنا
    }, 400);
    return () => clearTimeout(timeoutId);
  }, [inputValue, dispatch, fetchAction, extraQueryParams ]);

  // حقن خيار فتح الدايالوج كخيار أخير داخل القائمة بدل زر خارجي
  const DIALOG_OPTION_ID = "__open_dialog__";

  const buildOptions = React.useCallback(() => {
    if (!modalDialog) return options;
    const hasDialogOption = options.some(o => o?.id === DIALOG_OPTION_ID);
    if (hasDialogOption) return options;
    return [
      ...options,
      {
        id: DIALOG_OPTION_ID,
        [dataName]: modalOptionLabel || t("Advanced Search..."),
        _dialogTrigger: true
      }
    ];
  }, [options, modalDialog, dataName, modalOptionLabel]);

  const allOptions = buildOptions();
  

 

  const auto = (
    <Autocomplete
      multiple={multiple}
      disabled={disabled}
      id={`dynamic-dropdown-${fieldName}`}
      options={allOptions}
      value={currentValue}
      onChange={(_, newValue) => {
        const dialogSelected = Array.isArray(newValue)
          ? newValue.some((item) => item?.id === DIALOG_OPTION_ID)
          : newValue?.id === DIALOG_OPTION_ID;

        if (dialogSelected) {
          setDialogOpen(true);
          return;
        }

        if (onChange) {
          onChange(newValue);
        } else {
          formik.setFieldValue(fieldName, newValue);
        }
      }}
      getOptionLabel={(option) =>
        option?._dialogTrigger
          ? option[dataName] + (dataName2 && option[dataName2] ? ` (${option[dataName2]})` : "")
          : (option?.[dataName] + (dataName2 && option[dataName2] ? ` (${option[dataName2]})` : "") || "")
      }
      isOptionEqualToValue={(o, v) =>
        o?.id === v?.id
      }
      disableCloseOnSelect={multiple}
      loading={formState[loadingKey] === "pending"}
      sx={{ flex: 1, minWidth: 200 }}
      filterOptions={(opts) => opts} 
      renderOption={(props, option) => {
        if (option._dialogTrigger) {
          return (
            <li
              {...props}
              key={`dialog-option-${fieldName}-${option.id}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                fontWeight: 500,
                padding: '6px 12px',
                borderTop: '1px solid rgba(0,0,0,0.08)',
                background: '#f5f9fc'
              }}
              onMouseDown={(e) => e.preventDefault()} // منع فقدان التركيز قبل الفتح
              onClick={() => setDialogOpen(true)}
            >
             {option[dataName] + (dataName2 && option[dataName2] ? ` (${option[dataName2]})` : "")}

              <span style={{
                fontSize: 11,
                fontWeight: 500,
                opacity: .7,
                textTransform: 'uppercase'
              }}>{t("Open")}</span>
            </li>
          );
        }
        return (
          <li {...props} key={option.id}>
            {option?.[dataName] + (dataName2 && option[dataName2] ? ` (${option[dataName2]})` : "") || ""}
          </li>
        );
      }}
      renderInput={(params) => {
        const adorn = (
          <>
            {formState[loadingKey] === "pending" && (
              <CircularProgress color="inherit" size={18} />
            )}
            {params.InputProps.endAdornment}
          </>
        );
        return (
          <TextField
            {...params}
            label={t(label)}
            onChange={(e) => setInputValue(e.target.value)}
            error={hasError}
            helperText={hasError ? errorMsg : undefined}
            InputProps={{
              ...params.InputProps,
              endAdornment: adorn
            }}
          />
        );
      }}
    />
  );



  const onSelect = (value) => {

    if (onChange){

      onChange(value);
    } else{

    formik.setFieldValue(fieldName, value);

    }
   
  }

  if (!modalDialog) return auto;

  const renderedDialog = React.isValidElement(modalDialog)
    ? React.cloneElement(modalDialog, {
        open: dialogOpen,
        onClose: () => setDialogOpen(false),
        onSelect: (value) => {
          onSelect(value);
          setDialogOpen(false);
        }
      })
    : null;

  return (
    <>
      {auto}
      {renderedDialog}
    </>
  );
}

DynamicDropDownlist.propTypes = {
  label: PropTypes.string.isRequired,
  formik: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  loadingKey: PropTypes.string.isRequired,
  dataKey: PropTypes.string.isRequired,
  fetchAction: PropTypes.func.isRequired,
  errorKey: PropTypes.string.isRequired,
  dataName: PropTypes.string,
  dataName2: PropTypes.string,
  modalDialog: PropTypes.node,
  modalOptionLabel: PropTypes.string,
  onChange: PropTypes.func,
  extraQueryParams: PropTypes.object,
  multiple: PropTypes.bool,
};

export default DynamicDropDownlist;
